import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import TextField from '@material-ui/core/TextField';
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { withStyles } from '@material-ui/core';
import { displayDateTimeFormat, dateTimePickerFormat } from '../../../../../utils/staticData';
import { useEffect } from 'react';

const useStyles = theme => ({
    icon: {
        margin: 0,
        padding: 0,
        marginLeft: theme.spacing(1)
    },
    datePicker: {
        minWidth: 200,
        padding: 0,
        marginLeft: theme.spacing(1)
    },
    container: {
        width: 215,
    }
});

const TextFieldComponent = (props) => {
    return <TextField {...props} disabled={true} />;
};

const DatePicker = ({ classes, visible, date, onChange, onDatePickerClose, minDate, maxDate }) => {
    const [value, setValue] = useState(date);

    useEffect(() => {
        setValue(date);
    }, [date]);

    const handleDateChange = e => {
        setValue(moment(e).unix());
        if(onChange)
            onChange(moment(e).unix());
    };

    return (
            <div className={classes.container}>
                {visible ?
                <KeyboardDateTimePicker
                    ampm={false}
                    format={displayDateTimeFormat}
                    minDate={minDate ? moment.unix(minDate) : moment.unix(0)}
                    maxDate={moment.unix(maxDate)}
                    //variant="inline"
                    className={classes.datePicker}
                    value={moment.unix(value).format(dateTimePickerFormat)}
                    onChange={handleDateChange}
                    onClose={onDatePickerClose}
                    TextFieldComponent={TextFieldComponent}
                />
                :
                moment.unix(value).format(displayDateTimeFormat)}
            </div>
    );
};

export default withStyles(useStyles)(DatePicker);

DatePicker.propTypes = {
    classes: PropTypes.object,
    date: PropTypes.number,
    visible: PropTypes.bool,
    onChange: PropTypes.func,
    onDatePickerClose: PropTypes.func,
    maxDate: PropTypes.number,
    minDate: PropTypes.number,
};
